import axios from '../../utils/AxiosUtils';
import i18n from '../../i18next';
import { DEFAULT_PAGE_SIZE } from '../../utils/Constants';

import {
    LOADING,
    LOAD_RESTAURANTS_SUCCESS,
    LOAD_RESTAURANT_SUCCESS,
    UPDATE_RESTAURANT_SUCCESS,
    LOAD_RESTAURANTS_SUMMARY_SUCCESS,
    SAVE_RESTAURANT_SUCCESS,
    CLEAR_RESTAURANTS,
    CLEAR_RESTAURANT, LOAD_RESTAURANT_DETAILS_SUCCESS
} from '../types';
import MessageUtils from "../../utils/MessageUtils";
import { push } from "connected-react-router";
import { redirectToPageNotFound } from "../../utils/CommonUtils";
import { doLoadRestaurantSettings } from "./settings/service/GeneralServicesActions";

export const loadRestaurants = (currentPageNumber = 1, searchQuery) => {
    return (dispatch, getState) => {
        doLoadRestaurants(currentPageNumber, searchQuery, dispatch, getState);
    };
};

const doLoadRestaurants = (currentPageNumber = 1, searchQuery, dispatch, getState) => {
    dispatch({ type: LOADING, payload: true });

    let brandParameter = '';
    let countryParameter = '';
    let locationParameter = '';
    let posTypeParameter = '';
    let posStatusParameter = '';
    let managerParameter = '';
    let brandIdParameter = '';
    let workingStatusParameter = '';
    let restaurantPriorityParameter = '';
    if (searchQuery !== undefined) {
        if (searchQuery.brand !== undefined && searchQuery.brand !== '') {
            brandParameter = `&chainName=${searchQuery.brand}`
        }
        if (searchQuery.country !== undefined && searchQuery.country !== '') {
            countryParameter = `&country=${searchQuery.country}`
        }
        if (searchQuery.location !== undefined && searchQuery.location !== '') {
            locationParameter = `&location=${searchQuery.location}`
        }
        if (searchQuery.posType !== undefined && searchQuery.posType !== '') {
            posTypeParameter = `&posType=${searchQuery.posType}`
        }
        if (searchQuery.posStatus !== undefined && searchQuery.posStatus !== '') {
            posStatusParameter = `&posStatus=${searchQuery.posStatus}`

            if (searchQuery.posStatus === "PAUSED") {
                posStatusParameter = `&posPaused=true`
            }

            if (searchQuery.posStatus === "INACTIVE") { 
                posStatusParameter = `&inactive=true`
            }
        }
        if (searchQuery.manager !== undefined && searchQuery.manager !== '') {
            managerParameter = `&managerName=${searchQuery.manager}`
        }
        if (searchQuery.id !== undefined && searchQuery.id !== '') {
            brandIdParameter = `&id=${searchQuery.id}`
        }
        if (searchQuery.workingStatus !== undefined && searchQuery.workingStatus !== '') {
            workingStatusParameter = `&workingStatus=${searchQuery.workingStatus.toLowerCase()}`
        }
        if (searchQuery.restaurantPriority !== undefined && searchQuery.restaurantPriority !== '') {
            restaurantPriorityParameter = `&restaurantPriority=${searchQuery.restaurantPriority}`
        }
    }

    const url = `/restaurant/search?page=${currentPageNumber - 1}&size=${DEFAULT_PAGE_SIZE}${brandParameter}${countryParameter}${locationParameter}${posTypeParameter}${posStatusParameter}${managerParameter}${brandIdParameter}${workingStatusParameter}${restaurantPriorityParameter}`;

    axios().get(url)
        .then(response => loadRestaurantsSuccess(dispatch, response))
        .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:restaurantsActions.loadRestaurantsFailure')));
};

const loadRestaurantsSuccess = (dispatch, response) => {

    dispatch({ type: LOADING, payload: false });
    dispatch({ type: LOAD_RESTAURANTS_SUCCESS, payload: response.data });
};

export const pauseRestaurant = (restaurantPauseStatus, restaurantId, currentPageNumber = 1, searchQuery) => {
    return (dispatch, getState) => {

        dispatch({ type: LOADING, payload: true });
        const url = `/restaurant/${restaurantId}/pause`;
        const data = {
            'flag': restaurantPauseStatus
        }

        axios().put(url, data)
            .then(() => pauseRestaurantSuccess(currentPageNumber, searchQuery, dispatch, getState, restaurantPauseStatus))
            .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:restaurantsActions.pauseFailure')));
    };
};

const pauseRestaurantSuccess = (currentPageNumber, searchQuery, dispatch, getState, restaurantPauseStatus) => {

    if (restaurantPauseStatus) {
        MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:restaurantsActions.pauseSucces'));
    } else {
        MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:restaurantsActions.unpauseSuccess'));
    }

    doLoadRestaurants(currentPageNumber, searchQuery, dispatch, getState);
    doLoadRestaurantsSummary(dispatch, getState);
};

export const loadRestaurant = (id) => {
    return (dispatch) => {
        dispatch({ type: LOADING, payload: true });

        const url = `/restaurant/${id}/`;

        axios().get(url)
            .then(response => (response.status === 204 && (id != -1)) ? redirectToPageNotFound(dispatch) : loadRestaurantSuccess(dispatch, response))
            .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:restaurantsActions.loadRestaurantFailure')));
    };
};

const loadRestaurantSuccess = (dispatch, response) => {
    dispatch({ type: LOADING, payload: false });
    dispatch({ type: LOAD_RESTAURANT_SUCCESS, payload: response.data });
    dispatch({ type: LOAD_RESTAURANT_DETAILS_SUCCESS, payload: response.data });
};

export const saveRestaurant = (state, chain) => {
    return (dispatch, getState) => {
        dispatch({ type: LOADING, payload: true });

        if (chain.id === undefined || chain.id === null) {
            chain.id = state.brand.brand.id;
        }

        const url = `/restaurant-chain/${chain.id}/restaurant`;

        let restaurant = {
            id: null,
            name: state.name,
            address: state.address,
            displayAddress: state.displayAddress,
            location: state.location,
            phone: state.phone,
            email: state.email,
            locale: state.locale,
            timeZone: state.timeZone,
            restaurantPriority: state.restaurantPriority !== '' ? state.restaurantPriority : null,
            inactive: state.inactive
        };

        if (state.manager !== undefined && state.manager !== null) {
            restaurant['manager'] = state.manager;
        }

        axios().post(url, restaurant)
            .then(response => saveRestaurantSuccess(dispatch, getState, response))
            .catch(error => saveRestaurantError(dispatch, error));
    };
};

const saveRestaurantSuccess = (dispatch, getState, response) => {
    MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:posSettings.saveSuccess'));

    const restaurantId = response.data.id;
    doLoadRestaurantSettings(dispatch, getState, restaurantId);

    dispatch(push(`/restaurant/${response.data.id}/settings/general`));

    dispatch({ type: LOADING, payload: false });
    dispatch({ type: SAVE_RESTAURANT_SUCCESS, payload: response.data });
    dispatch({ type: LOAD_RESTAURANT_SUCCESS, payload: response.data });

};

const saveRestaurantError = (dispatch, error) => {
    if (error.response !== undefined) {
        MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:restaurantsActions.saveRestaurantFailure'));
    } else {
        dispatch({ type: LOADING, payload: false });
    }
}

export const updateRestaurant = (state) => {
    return (dispatch) => {
        dispatch({ type: LOADING, payload: true });

        const url = `/restaurant/${state.id}`;
        let restaurant = {
            id: state.id,
            name: state.name,
            address: state.address,
            displayAddress: state.displayAddress,
            location: state.location,
            phone: state.phone,
            email: state.email,
            locale: state.locale,
            timeZone: state.timeZone,
            restaurantPriority: state.restaurantPriority !== '' ? state.restaurantPriority : null,
            inactive: state.inactive
        };

        if (state.manager !== undefined && state.manager !== null) {
            restaurant['manager'] = state.manager;
        }

        axios().put(url, restaurant)
            .then(response => updateRestaurantSuccess(dispatch, response))
            .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:restaurantsActions.saveRestaurantFailure')));
    };
};

const updateRestaurantSuccess = (dispatch, response) => {
    MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:posSettings.saveSuccess'));
    dispatch({ type: LOADING, payload: false });
    dispatch({ type: UPDATE_RESTAURANT_SUCCESS, payload: response.data });
};

export const loadRestaurantsSummary = () => {
    return (dispatch, getState) => {
        doLoadRestaurantsSummary(dispatch, getState);
    }
}

const doLoadRestaurantsSummary = (dispatch, getState) => {
    dispatch({ type: LOADING, payload: true });

    const url = `/restaurant/pos-status-summary`;

    axios().get(url)
        .then(response => loadRestaurantsSummarySuccess(dispatch, response))
        .catch(error => MessageUtils.errorMessageResponse(
            dispatch, error.response.data, i18n.t('actions:restaurantsActions.loadRestsSummaryFailure')));
}

const loadRestaurantsSummarySuccess = (dispatch, response) => {
    dispatch({ type: LOADING, payload: false });
    dispatch({ type: LOAD_RESTAURANTS_SUMMARY_SUCCESS, payload: response.data });
}

export const pauseAllRestaurants = (restaurantPriority, toggleWarningModal) => {
    return (dispatch) => {
        const restaurantPriorityQuery = restaurantPriority !== '' ? restaurantPriority : null;

        const url = `/restaurant/pause/all?restaurantPriority=${restaurantPriorityQuery}`;

        axios().post(url, {})
        .then(response => {
            toggleWarningModal();
            MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:restaurantsActions.pauseAllSuccess'));
            dispatch(loadRestaurants());
            dispatch(loadRestaurantsSummary());
        })
        .catch(error => MessageUtils.errorMessageResponse(
            dispatch, error.response.data, i18n.t('actions:restaurantsActions.pauseAllFailure')));
    }
}

export const downloadRestaurantsList = (callback) => {
    return (dispatch) => {
        dispatch({ type: LOADING, payload: true });

        const url = `/restaurant/restaurant-list`;

        axios().post(url, {})
            .then(res => {
                let blob = new Blob([res.data], { type: 'application/csv' });
                let link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = `restaurants_orders_list.csv`;
                link.click();
                if (callback) {
                    callback();
                }
            })
            .catch(err => MessageUtils.errorMessageResponse(
                dispatch, err.response.data, i18n.t('actions:restaurantsActions.downloadFail')))
            .finally( dispatch({ type: LOADING, payload: false }));
    }
}

export const clearRestaurants = (dispatch) => {
    return (dispatch) => {
        dispatch({ type: CLEAR_RESTAURANTS });
    }
}

export const clearRestaurant = (dispatch) => {
    return (dispatch) => {
        dispatch({ type: CLEAR_RESTAURANT });
    }
};



// WEBPACK FOOTER //
// ./src/actions/restaurants/RestaurantsActions.js